import {combineReducers} from 'redux';

import profileMenu from './profile-menu/reducer';

export interface TopBarState {
    profileMenu: any;
}

export default combineReducers<TopBarState>({
    profileMenu,
});
